import { html, cssManager } from '@design.estate/dees-element';

export const demo = () => html`
  <style>
    .demo-container {
      padding: 48px;
      background: ${cssManager.bdTheme('#f8f9fa', '#0a0a0a')};
      display: flex;
      flex-direction: column;
      gap: 32px;
    }

    .section {
      max-width: 900px;
      width: 100%;
      margin: 0 auto;
    }

    .section-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 8px;
      color: ${cssManager.bdTheme('#09090b', '#fafafa')};
    }

    .section-description {
      font-size: 14px;
      color: ${cssManager.bdTheme('#71717a', '#a1a1aa')};
      margin-bottom: 16px;
    }

    dees-image-viewer {
      height: 400px;
      border: 1px solid ${cssManager.bdTheme('#e5e7eb', '#27272a')};
      border-radius: 8px;
      overflow: hidden;
    }

    .compact {
      height: 250px;
    }
  </style>

  <div class="demo-container">
    <div class="section">
      <div class="section-title">JPEG Image with Toolbar</div>
      <div class="section-description">A landscape photo with zoom, pan, fit, and download controls.</div>
      <dees-image-viewer
        src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1200"
        alt="Mountain landscape"
      ></dees-image-viewer>
    </div>

    <div class="section">
      <div class="section-title">PNG with Transparency</div>
      <div class="section-description">Transparent PNG displayed on a checkerboard background.</div>
      <dees-image-viewer
        src="https://upload.wikimedia.org/wikipedia/commons/4/47/PNG_transparency_demonstration_1.png"
        alt="PNG transparency demo"
      ></dees-image-viewer>
    </div>

    <div class="section">
      <div class="section-title">SVG Image</div>
      <div class="section-description">Scalable vector graphic.</div>
      <dees-image-viewer
        src="https://upload.wikimedia.org/wikipedia/commons/0/02/SVG_logo.svg"
        alt="SVG logo"
        fit="contain"
      ></dees-image-viewer>
    </div>

    <div class="section">
      <div class="section-title">No Toolbar Variant</div>
      <div class="section-description">Image viewer with the toolbar hidden.</div>
      <dees-image-viewer
        class="compact"
        src="https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800"
        alt="Nature scene"
        .showToolbar=${false}
      ></dees-image-viewer>
    </div>
  </div>
`;
